import React, { useState } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { Button, ContactInfoForm, SvgIcon } from 'components'
import { isEqual } from 'lodash'
import { MobileVerificationModal } from '../profileCreation/MobileVerificationModal'

const useStyles = makeStyles({
  selectIcon: {
    marginRight: '7px',
  },
  saveButton: {
    width: 80,
    marginLeft: 24,
  },
  buttons: {
    display: 'flex',
    justifyContent: 'end',
    marginBottom: 31,
  },
})

const ContactInfoSection = props => {
  const {
    changeContactInfo,
    saveProfileContactInfo,
    states,
    provinces,
    contactInfo,
    countries,
    containerClass,
    showSnackbar,
    updateLocalContactInfo,
    executeScroll,
    languages,
    languagesDB,
    saveCurrentUserLanguages,
    updateLocalUserLanguages,
  } = props
  const classes = useStyles()
  const [isSubmit, setIsSubmit] = useState(false)
  const [verifyNumber, setVerifyNumber] = useState('')
  const onClose = () => setVerifyNumber('')
  const mockCountries = [
    {
      label: 'USA',
      value: 840,
      icon: (
        <SvgIcon classes={{ root: classes.selectIcon }}>
          <path fill="#F0F0F0" d="M16 2.667H0v10.666h16V2.667z" />
          <path
            fill="#D80027"
            d="M16 4H0v1.333h16V4zM16 6.667H0V8h16V6.667zM16 9.333H0v1.333h16V9.333zM16 12H0v1.333h16V12z"
          />
          <path fill="#2E52B2" d="M8 2.667H0V8.41h8V2.667z" />
          <path
            fill="#F0F0F0"
            d="M3.12 5.02l-.129.396h-.417l.337.245-.128.396.337-.245.337.245-.129-.396.337-.245h-.417L3.12 5.02zM3.248 6.846L3.12 6.45l-.129.396h-.417l.337.245-.128.396.337-.244.337.244-.129-.396.337-.245h-.417zM1.487 6.846l-.129-.396-.129.396H.812l.338.245-.13.396.338-.244.337.244-.129-.396.337-.245h-.416zM1.358 5.02l-.129.396H.812l.338.245-.13.396.338-.245.337.245-.129-.396.337-.245h-.416l-.129-.396zM3.12 3.59l-.129.395h-.417l.337.245-.128.397.337-.245.337.245-.129-.397.337-.245h-.417L3.12 3.59zM1.358 3.59l-.129.395H.812l.338.245-.13.397.338-.245.337.245-.129-.397.337-.245h-.416l-.129-.396zM4.881 5.02l-.128.396h-.417l.337.245-.129.396.338-.245.337.245-.13-.396.338-.245H5.01l-.128-.396zM5.01 6.846l-.128-.396-.13.396h-.416l.337.245-.129.396.338-.244.337.244-.13-.396.338-.245H5.01zM6.77 6.846L6.64 6.45l-.129.396h-.416l.337.245-.129.396.337-.244.337.244-.129-.396.338-.245H6.77zM6.641 5.02l-.129.396h-.416l.337.245-.129.396.337-.245.337.245-.129-.396.338-.245H6.77L6.64 5.02zM4.881 3.59l-.128.395h-.417l.337.245-.129.397.338-.245.337.245-.13-.397.338-.245H5.01l-.128-.396zM6.641 3.59l-.129.395h-.416l.337.245-.129.397.337-.245.337.245-.129-.397.338-.245H6.77L6.64 3.59z"
          />
        </SvgIcon>
      ),
    },
    {
      label: 'Canada',
      value: 124,
      icon: (
        <SvgIcon classes={{ root: classes.selectIcon }}>
          <path
            d="M1.77778 2.22217C1.30628 2.22217 0.854097 2.40947 0.520699 2.74287C0.187301 3.07626 0 3.52845 0 3.99995L0 11.9999C0 12.4714 0.187301 12.9236 0.520699 13.257C0.854097 13.5904 1.30628 13.7777 1.77778 13.7777H4.44444V2.22217H1.77778ZM14.2222 2.22217H11.5556V13.7777H14.2222C14.6937 13.7777 15.1459 13.5904 15.4793 13.257C15.8127 12.9236 16 12.4714 16 11.9999V3.99995C16 3.52845 15.8127 3.07626 15.4793 2.74287C15.1459 2.40947 14.6937 2.22217 14.2222 2.22217Z"
            fill="#D52B1E"
          />
          <path d="M4.44434 2.22217H11.5554V13.7777H4.44434V2.22217Z" fill="#EEEEEE" />
          <path
            d="M8.27331 9.82781C8.80575 9.88959 9.28309 9.94514 9.81509 10.006L9.67953 9.5607C9.66956 9.52238 9.67093 9.48199 9.68347 9.44443C9.69602 9.40688 9.7192 9.37377 9.7502 9.34914L11.2964 8.08959L10.9764 7.93892C10.8355 7.8887 10.8742 7.80914 10.9253 7.61803L11.1613 6.75759L10.2631 6.94736C10.1755 6.9607 10.1173 6.90514 10.104 6.85181L9.98798 6.44692L9.27775 7.24425C9.17686 7.37225 8.97242 7.37225 9.03598 7.07714L9.33953 5.46203L8.93198 5.67314C8.81775 5.73714 8.70353 5.74781 8.63998 5.63359L8.07775 4.58203L7.51553 5.63359C7.45153 5.74781 7.33731 5.73714 7.22309 5.67314L6.81598 5.46203L7.11953 7.07714C7.18353 7.37225 6.97864 7.37225 6.87775 7.24425L6.16753 6.44736L6.05198 6.85225C6.03864 6.90559 5.97998 6.96114 5.89242 6.94781L4.9942 6.75803L5.2302 7.61848C5.28042 7.80959 5.31953 7.88914 5.17864 7.93936L4.85864 8.09003L6.40486 9.34959C6.4662 9.39714 6.49731 9.48292 6.47509 9.56114L6.33953 10.0065L7.88175 9.82825C7.92886 9.82825 7.95998 9.85448 7.95953 9.9087L7.86442 11.5549H8.28931L8.19464 9.9087C8.19553 9.85403 8.2262 9.82781 8.27331 9.82781Z"
            fill="#D52B1E"
          />
        </SvgIcon>
      ),
    },
  ]

  const updateContactInfo = event => {
    updateLocalContactInfo({
      [event.target.name]: event.target.value,
    })
  }

  const onSubmit = async values => {
    try {
      setIsSubmit(true)
      const v = await saveProfileContactInfo(values)
      await saveCurrentUserLanguages(languagesDB)
      changeContactInfo(values)
      showSnackbar('success', 'Contact info changed')
      setIsSubmit(false)
      if (!v.is_phone_confirmed) setVerifyNumber(v.phone)
    } catch (e) {
      showSnackbar('error', 'There was some error while changing contact info')
      setIsSubmit(false)
    } finally {
      executeScroll()
    }
  }

  const onReset = () => {
    executeScroll()
    updateLocalUserLanguages(languages)
    updateLocalContactInfo({
      ...contactInfo,
    })
  }

  const Footer = ({ disabled }) => (
    <div className={classes.buttons}>
      <Button variant="text" disabled={(disabled && isEqual(languages, languagesDB)) || isSubmit} type="reset">
        cancel
      </Button>
      <Button
        type="submit"
        variant="primary"
        disabled={(disabled && isEqual(languages, languagesDB)) || isSubmit}
        className={classes.saveButton}
        isButtonBlocked={isSubmit}
        circularSize={22}
      >
        Save
      </Button>
    </div>
  )

  return (
    <div className={containerClass}>
      <ContactInfoForm
        onReset={onReset}
        updateContactInfo={updateContactInfo}
        languages={languages}
        languagesDB={languagesDB}
        saveCurrentUserLanguages={saveCurrentUserLanguages}
        updateLocalUserLanguages={updateLocalUserLanguages}
        onSubmit={onSubmit}
        contactInfo={contactInfo}
        countries={mockCountries}
        states={states}
        provinces={provinces}
        footer={<Footer />}
      />
      <MobileVerificationModal open={!!verifyNumber} number={verifyNumber} onOk={onClose} onClose={onClose} />
    </div>
  )
}

export default ContactInfoSection
